/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card price drop message instance
 *
 * @module enervee_utils.product_card
 */
function productCardPriceDropMessageDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '='
        },
        controller: productCardPriceDropMessageController,
        template: require('./priceDropMessageView.html')
    };
}

productCardPriceDropMessageController.$inject = ['$scope', 'CmsContentService', 'ProductCardService'];
function productCardPriceDropMessageController ($scope, CmsContentService, ProductCardService) {
    $scope.product.hasPriceDrop = false;

    CmsContentService.getMarketPlaceText(
        'product_card:price_drop',
        {},
        $scope.product.category.id
    ).then(function (text) {
        $scope.priceDropText = text;
    });

    $scope.$watch('product.priceChange', function () {
        if ($scope.product.priceChange) {
            var priceDropInfo = $scope.product.priceChange.price_drop_information;
            if (priceDropInfo) {
                $scope.product.hasPriceDrop = priceDropInfo.price_direction === 'drop';
            } else {
                $scope.product.hasPriceDrop = false;
            }
        }
        if ($scope.product.hasPriceDrop) {
            ProductCardService.getCardAriaText($scope.product);
        }
    });
}

module.exports = productCardPriceDropMessageDirective;
